mainApp.component('slaSettingsGeneral', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-general-configuration.component.html',
    bindings: {
        model: '=',
        siteId: '<?',
        showOverrideCheckbox: '<?',
    },
    controller: slaSettingsGeneralConfigurationController,
});


function slaSettingsGeneralConfigurationController(SlaSettingService) {
    const ctrl = this;

    ctrl.$onInit = () => {
        const isSmartSettings = ctrl.model &&
            SlaSettingService.DEFAULT_EVALUATION_PERIOD_IN_SEC == ctrl.model.evaluationPeriod &&
            SlaSettingService.DEFAULT_PACKET_LOSS_IN_PERCENT == ctrl.model.packetLoss &&
            SlaSettingService.DEFAULT_AVERAGE_LATENCY_IN_MILLISECONDS == ctrl.model.averageLatency;

        ctrl.settingsType = isSmartSettings && !ctrl.siteId ? SlaSettingService.SMART_SETTINGS : SlaSettingService.CUSTOM_SETTINGS;
    }

    ctrl.disableInput = () => {
        return ctrl.siteId && !ctrl.model?.overrideAccountGeneralSettings;
    }

    /**
     * As instructed by Product (@Timor sherf)
     *
     * When the user chooses to use custom setting,
     * We want the user to manually choose a number for "evaluationPeriod"
     * If the evaluation period is set to DEFAULT_EVALUATION_PERIOD_IN_SEC this will trigger the "SMART SETTINGS" in catoD
     * Thus we put in for evaluationPeriod INITIAL_CUSTOM_EVALUATION_PERIOD_IN_SEC
     */
    ctrl.setEvaluationPeriodToInitialCustomValue = () => {
        if (ctrl.settingsType === SlaSettingService.CUSTOM_SETTINGS){
            ctrl.model.evaluationPeriod = SlaSettingService.INITIAL_CUSTOM_EVALUATION_PERIOD_IN_SEC;
        }
    }

    ctrl.setValuesToDefault = () => {
        if (ctrl.settingsType === SlaSettingService.SMART_SETTINGS){
            ctrl.model.averageLatency = SlaSettingService.DEFAULT_AVERAGE_LATENCY_IN_MILLISECONDS;
            ctrl.model.packetLoss = SlaSettingService.DEFAULT_PACKET_LOSS_IN_PERCENT;
            ctrl.model.evaluationPeriod = SlaSettingService.DEFAULT_EVALUATION_PERIOD_IN_SEC;
        }
    }
};
